import { useEffect, useState } from 'react';
import { ArrowRight } from 'lucide-react';
import { trackEvent } from '@/lib/analytics';

export default function MobileLeadButton() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const hero = document.getElementById('home');
    const form = document.getElementById('contact');
    if (!hero || !form) return;
    let pastHero = false;
    let formVisible = false;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.target === hero) pastHero = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
        if (entry.target === form) formVisible = entry.isIntersecting;
      });
      setVisible(pastHero && !formVisible);
    });
    observer.observe(hero);
    observer.observe(form);
    return () => observer.disconnect();
  }, []);
  if (!visible) return null;
  return (
    <a
      href="#demo-contact-form"
      className="fixed bottom-5 left-4 right-24 z-40 flex h-14 items-center justify-center gap-2 rounded-xl bg-brand-600 hover:bg-brand-700 px-3 text-sm font-semibold text-white shadow-lg focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 sm:hidden"
      style={{ marginBottom: 'env(safe-area-inset-bottom, 0px)' }}
      onClick={() => trackEvent('lead-cta-click', { placement: 'mobile_sticky' })}
    >
      Ücretsiz tanıtım isteyin <ArrowRight className="h-4 w-4" aria-hidden="true" />
    </a>
  );
}
